import React from "react";
import { IconInbox, IconMousePointerClick } from "./CareWatchIcons";

export const CareWatchEmptyQueue = ({ variant = "signals" }) => {
  const isLive = variant === "live";
  return (
    <div className="flex min-h-0 flex-1 flex-col items-center justify-center px-6 text-center">
      <div className="flex flex-col items-center justify-center gap-2.5">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#F1F5F9]">
          <IconInbox size={32} stroke="#94A3B8" />
        </div>
        <p className="text-[18px] font-semibold leading-6 text-[#334155]">
          {isLive ? "No live shifts" : "No flagged timesheets"}
        </p>
        <p className="w-[420px] max-w-full text-[13px] font-medium leading-5 text-[#64748B]">
          {isLive
            ? "Nothing is in progress, late to start, or running late. The floor is quiet for this filter."
            : "Nothing matched your filters in this period. Try widening the date range or clearing filters."}
        </p>
      </div>
    </div>
  );
};

export const CareWatchEmptyDetail = ({ variant = "signals" }) => {
  const isLive = variant === "live";
  return (
    <div className="flex h-full min-h-0 flex-1 flex-col items-center justify-center gap-3 p-4 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#F1F5F9]">
        <IconMousePointerClick size={28} className="text-[#94A3B8]" />
      </div>
      <p className="text-base font-semibold leading-6 text-[#334155]">
        {isLive ? "Select a live shift" : "Select a row to review"}
      </p>
      <p className="w-[260px] max-w-full text-[13px] font-medium leading-5 text-[#64748B]">
        {isLive
          ? "Choose an in-progress, not-started, or running-late shift to see clock-in status."
          : "Choose a flagged timesheet from the table to see the shift note, AI context, and create an incident if needed."}
      </p>
    </div>
  );
};
